import React from "react";
import {
  NavLink,
  useParams,
} from "react-router-dom";
import titleize from "underscore.string/titleize";
import { Layouts, Loaders } from "../components";
import {StatusIndicator} from "./../components/preoffer";
import PitchEditor from "../components/PitchEditor";
import { 
  usePreoffer,
} from "./../queries/preoffer";

function OfferEdit() {

  let { preoffer_id } = useParams();
  const {data:preoffer, isLoading } = usePreoffer({preoffer_id});

  if(isLoading)
    return <Loaders.ViewPageLoader />

  return (
    <div className="bg-white mvh-100">
      <Layouts.PageHeader left={titleize(preoffer.name)} right={ <StatusIndicator preoffer={preoffer} /> } />
      <div className="overview-content">
        <div className="nav-tabs-container">
          <ul className="nav nav-tabs px-3" role="tablist">
            <li className="nav-item">
              <NavLink to="pitch-editor" className="nav-link active" data-bs-toggle="tab" data-bs-target="#pitch-editor" role="tab">Pitch</NavLink>
            </li>
          </ul>
        </div>
        <div className="tab-content px-3 pt-3 pb-5">
          <div className="tab-pane fade show active" id="pitch-editor" role="tabpanel">
            <PitchEditor
              pitchableType="preoffer"
              pitchableId={preoffer_id}
              />
          </div>
        </div>
      </div>
    </div>
  )
}

export default OfferEdit;